import React from 'react';
import {FaCar, FaUser} from "react-icons/fa";
import {getValue} from "../utils.js";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import BaseNode from "./base-node.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";
import CheckHasData from "../check-has-data.jsx";

const Encounter = ({ data, selected }) => {
    const navigate = navigateHook();
    const {toggleItemsNode} = useEdgeBuilder();
    const title = () => {
        return (
            <>
                <p className={"!mb-[2px]"}><b>Abordagem</b></p>
                <p className={"mb-0 text-[6px]"}>{projectUtils.formatDate(data.date)}</p>
            </>
        )
    }

    const icon = (
        <img
            className="w-full"
            src={getAssetPath("img/dashboard-svg/sw.approach.svg")}
            alt="image"
        />
    );

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            {
                toggleItemsNode.encounter.individuals &&
                <div className={"flex items-center"}>
                    <FaUser />
                    <p className={"ml-1 mb-0"}>
                        <CheckHasData value={getValue(data.individuals, "indivíduos", "indivíduo")} />
                    </p>
                </div>
            }

            {
                toggleItemsNode.encounter.vehicles &&
                <div className={"flex items-center"}>
                    <FaCar />
                    <p className={"ml-1 mb-0"}>
                        <CheckHasData value={getValue(data.vehicles, "veículos", "veículo")} />
                    </p>
                </div>

            }
        </div>
    );

    const handleSearchConnections = () => {
    }

    const open = () => {
        const urlDev = `/encounter/form/${data.id}`

        navigate(urlDev, true);
    }

    return (
        <BaseNode
            icon={icon}
            title={title()}
            image={null}
            infoBlock={infoBlock}
            onSearchConnections={handleSearchConnections}
            onSearchAll={() => {}}
            onExtraAction={open}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#287499]"}
            bgBody={"bg-[#e0f0f6]"}
        />
    );
};

export default Encounter;